module.exports = __webpack_public_path__ + "static/img/rz-28.d1c8ba6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rz-28.jpg
// module id = B+yf
// module chunks = 0